import { useMemo } from 'react'
import { db } from '@/lib/db'
import { useProfile } from './useProfile'
import type { GenerationLog, Organization } from '@/types'

/**
 * 额度管理 Hook
 * 查询企业今日额度使用情况
 */
export function useQuota() {
  const { profile } = useProfile()
  const orgId = profile?.org_id

  // 查询企业信息（获取限额）
  const { data: orgData } = db.useQuery(
    orgId
      ? {
          organizations: {
            $: {
              where: { id: orgId },
            },
          },
        }
      : {}
  )

  // 查询今日生成日志
  const dateString = useMemo(() => {
    // 获取北京时间日期字符串 YYYY-MM-DD
    // 注意：这里使用 Date.now() + 8h 来模拟北京时间，确保前后端一致
    return new Date(Date.now() + 8 * 3600000).toISOString().split('T')[0]
  }, [])

  const { data: logsData } = db.useQuery(
    orgId
      ? {
          generation_logs: {
            $: {
              where: {
                org_id: orgId,
                date_string: dateString,
              },
            },
          },
        }
      : {}
  )

  const organization = orgData?.organizations?.[0] as Organization | undefined
  const logs = (logsData?.generation_logs || []) as GenerationLog[]

  const dailyLimit = organization?.daily_limit ?? 300
  const todayUsage = logs.length
  const remaining = Math.max(0, dailyLimit - todayUsage)
  const percentage = dailyLimit > 0 ? (todayUsage / dailyLimit) * 100 : 0
  const isNearLimit = percentage >= 90 // 90% 以上视为接近限额

  return {
    dailyLimit,
    todayUsage,
    remaining,
    percentage,
    isNearLimit,
    isExceeded: todayUsage >= dailyLimit,
    organization,
  }
}


